import { resolveMemberMediaUrl } from '@formosa/shared/utils/mediaUrl';
import { resolveReadMedia } from '../social-post/socialPostMediaModel';
import { normalizeQuotedPostReference } from '../social-post/socialQuoteReferenceModel';
import { travelMemberProductDisplayName } from '../member-identity/memberIdentityPresentation';

export const DISCOVERY_KINDS = Object.freeze([
  'ALL', 'MOOD', 'JOURNEY', 'JOURNEY_INVITATION', 'PLACE', 'FOOD',
]);

function snowflakeId(value) {
  if (value == null || value === '') return null;
  const id = String(value);
  return /^[1-9]\d*$/.test(id) ? id : null;
}

function nonNegative(value) {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : 0;
}

export function normalizeDiscoveryItem(item) {
  const card = item?.card || {};
  const postId = snowflakeId(card.socialPostId ?? item?.postId);
  if (!postId) return null;
  const author = card.author || item?.author || {};
  const engagement = card.engagement || {};
  const journeyCard = card.journey;
  const journeyLink = item?.linkedJourneyPublication;
  const journeySource = journeyCard || journeyLink;
  const journey = journeySource?.available ? journeySource : null;
  const linkedLocation = item?.linkedLocation;
  const coverFileReference = card.coverFileReference || item?.coverFileReference || '';
  const quote = normalizeQuotedPostReference(
    item?.quotedPost || card.quotedPost,
    item?.quotedSocialPostId ?? card.quotedSocialPostId,
  );
  return {
    postId,
    kind: card.postKind || item?.postKind || 'MOOD',
    text: card.textContent || item?.textContent || '',
    publishedAt: card.publishedAt || item?.publishedAt || null,
    coverFileReference,
    coverUrl: resolveMemberMediaUrl(coverFileReference),
    media: resolveReadMedia({
      media: item?.media ?? card.media,
      coverFileReference,
    }),
    author: {
      memberId: snowflakeId(author.memberId) || snowflakeId(item?.authorMemberId),
      displayName: travelMemberProductDisplayName({
        displayName: author.displayName,
        username: author.username,
        nickname: author.nickname,
      }),
      avatarUrl: resolveMemberMediaUrl(author.avatarUrl),
    },
    journey: journey ? {
      publicationId: snowflakeId(journey.publicationId),
      title: journey.title || 'Shared journey',
      summary: journey.summary || '',
      coverUrl: resolveMemberMediaUrl(journey.coverFileReference),
    } : null,
    journeyUnavailable: Boolean(journeySource && journeySource.available === false),
    location: linkedLocation?.available ? {
      locationId: snowflakeId(linkedLocation.locationId),
      displayName: linkedLocation.displayName || 'Shared location',
      available: true,
      latitude: linkedLocation.latitude,
      longitude: linkedLocation.longitude,
    } : null,
    quote,
    engagement: {
      likeCount: nonNegative(engagement.likeCount ?? item?.likeCount),
      saveCount: nonNegative(engagement.saveCount ?? item?.saveCount),
      commentCount: nonNegative(engagement.commentCount ?? item?.commentCount),
      liked: Boolean(engagement.liked ?? item?.liked),
      saved: Boolean(engagement.saved ?? item?.saved),
      followingAuthor: Boolean(engagement.followingAuthor ?? item?.followingAuthor),
    },
  };
}

export function normalizeDiscoveryPage(payload) {
  return {
    items: Array.isArray(payload?.items)
      ? payload.items.map(normalizeDiscoveryItem).filter(Boolean)
      : [],
    nextCursor: payload?.nextCursor || null,
    hasMore: Boolean(payload?.hasMore),
  };
}
